import EFVideo from '@/components/UI/EFVideo';
import { roundFloat } from '@/utils/common';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

let videoSceneE: any = null,
    textSceneE: any = null;
export default function E() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [isClient, setIsClient] = useState(false);
    const videoRefPC = useRef();
    const videoRefH5 = useRef();
    // const [sources, setSources] = useState();
    const [isEnterA, setIsInterA] = useState(false);
    const [isEnterA2, setIsInterA2] = useState(false);
    const [isEnterB, setIsInterB] = useState(false);
    const [isEnterB2, setIsInterB2] = useState(false);
    const [isEnterC, setIsInterC] = useState(false);
    const initVideoSrcFnPc = async () => {
        const url = 'https://websiteoss.ecoflow.com/upload/video/1744081656367/5_pc.mp4';
        try {
            const blobUrl = await transformToBob(url);
            videoRefPC.current.current.src = blobUrl;
        } catch (error: any) {
            videoRefPC.current.current.src = url;
        }
    };
    const initVideoSrcFnH5 = async () => {
        const url = 'https://websiteoss.ecoflow.com/upload/video/1742782151268/5_h5.mp4';
        try {
            const blobUrl = await transformToBob(url);
            videoRefH5.current.current.src = blobUrl;
        } catch (error: any) {
            videoRefH5.current.current.src = url;
        }
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (videoSceneE) {
                    AniContainer.removeScene(videoSceneE);
                    videoSceneE = null;
                }
                if (textSceneE) {
                    AniContainer.removeScene(textSceneE);
                    textSceneE = null;
                }

                const isPC = window?.innerWidth > 1024;
                const video: any = isPC ? videoRefPC?.current : videoRefH5?.current;

                const startA = 0.24;
                const startA2 = 0.4;
                const startB = 0.545;
                const startB2 = 0.76;
                const startC = 0.8;
                videoSceneE = AniContainer.create({
                    triggerElement: '.dpu-detail-E',
                    triggerHook: 1,
                    offset: '50%',
                    duration: '450%',
                    onProcess: (process: number) => {
                        try {
                            const duration: number = video?.current?.duration;
                            if (isNaN(duration)) return;
                            let currentTime = roundFloat(duration * process, 2) || 0;
                            currentTime = Math.round(currentTime * 100) / 100;

                            if (process < startA) {
                                setIsInterA(false);
                                setIsInterA2(false);
                                setIsInterB(false);
                                setIsInterB2(false);
                                setIsInterC(false);
                            } else if (process >= startA && process < startA2) {
                                setIsInterA(true);
                                setIsInterA2(false);
                                setIsInterB(false);
                                setIsInterB2(false);
                                setIsInterC(false);
                            } else if (process >= startA2 && process < startB) {
                                setIsInterA(false);
                                setIsInterA2(true);
                                setIsInterB(false);
                                setIsInterB2(false);
                                setIsInterC(false);
                            } else if (process >= startB && process < startB2) {
                                setIsInterA(false);
                                setIsInterA2(false);
                                setIsInterB(true);
                                setIsInterB2(false);
                                setIsInterC(false);
                            } else if (process >= startB2 && process < startC) {
                                setIsInterA(false);
                                setIsInterA2(false);
                                setIsInterB(false);
                                setIsInterB2(true);
                                setIsInterC(false);
                            } else if (process >= startC) {
                                setIsInterA(false);
                                setIsInterA2(false);
                                setIsInterB(false);
                                setIsInterB2(false);
                                setIsInterC(true);
                            }
                            // console.log('duration -- currentTime', duration, currentTime);
                            video?.setCurrentTime(currentTime);
                        } catch (e) {
                            console.error(e);
                        }
                    },
                    onLazyLoad: async () => {
                        try {
                            const isPC = window?.innerWidth > 1024;
                            if (isPC) {
                                initVideoSrcFnPc();
                            } else {
                                initVideoSrcFnH5();
                            }

                            //setSources([`/responsive/video/delta-pro-ultra/launch/5_${isPC ? 'pc' : 'h5'}.mp4`]);
                            // setSources([`/responsive/video/delta-pro-ultra/launch/temp.mp4`]);
                        } catch (e) {
                            console.error(e);
                        }
                    },
                    lazyHook: 3.5,
                });

                // textSceneE = AniContainer.create({
                //     asyncFromTo: [
                //         ['.dpu-detail-E .textBox .text1', { opacity: 0, y: 160 }, { opacity: 1, y: 0 }, 0.5],
                //         ['.dpu-detail-E .textBox .text1', { opacity: 1, y: 0 }, { opacity: 0, y: -120 }, 0.5],
                //         ['.dpu-detail-E .textBox .text2', { opacity: 0, y: 160 }, { opacity: 1, y: 0 }, 0.5],
                //         ['.dpu-detail-E .textBox .text2', { opacity: 1, y: 0 }, { opacity: 0, y: -120 }, 0.5],
                //         ['.dpu-detail-E .textBox .text3 .subtitle', { opacity: 0, y: 120 }, { opacity: 1, y: 0 }, 0.5],
                //         ['.dpu-detail-E .textBox .text3 .title', { opacity: 0, y: 140 }, { opacity: 1, y: 0 }, 0.5],
                //         ['.dpu-detail-E .textBox .text3 .desc', { opacity: 0, y: 160 }, { opacity: 1, y: 0 }, 0.5],
                //         ['.dpu-detail-E .textBox .text3', { opacity: 1 }, { opacity: 1 }, 2.5],
                //     ],
                //     asyncTimeLine: [3.5, 5, 6, 8.5, 12, 12.1, 12.2, 12.5],
                //     triggerElement: '.dpu-detail-E',
                //     triggerHook: 1,
                //     offset: '50%',
                //     duration: '450%',
                // });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (videoSceneE) {
                    AniContainer.removeScene(videoSceneE);
                    videoSceneE = null;
                }
                if (textSceneE) {
                    AniContainer.removeScene(textSceneE);
                    textSceneE = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <section className={`dpu-detail-E dpu-detail-section ${css['dpu-detail-E']}`}>
            <div className="sticky-box">
                <div
                    className={`video-box${isEnterA ? ' isEnterA' : ''}${isEnterA2 ? ' isEnterA2' : ''}${isEnterB ? ' isEnterB' : ''}${
                        isEnterB2 ? ' isEnterB2' : ''
                    }${isEnterC ? ' isEnterC' : ''}`}
                >
                    <EFVideo
                        ref={videoRefPC}
                        // sources={sources}
                        className="video pc"
                        id="dpu-detail-E-video-pc"
                        muted
                        autoPlay={false}
                        loop={false}
                        preload="auto"
                        width="100%"
                        height="100%"
                        playsInline
                        aria-label="EcoFlow DELTA Pro Ultra"
                    />
                    <EFVideo
                        ref={videoRefH5}
                        // sources={sources}
                        className="video h5"
                        muted
                        autoPlay={false}
                        loop={false}
                        preload="auto"
                        width="100%"
                        height="100%"
                        playsInline
                        aria-label="EcoFlow DELTA Pro Ultra"
                    />
                    <div className="opacity-c-layer"></div>
                    <div className={`textBox`}>
                        <div className="text-ani text1">
                            <p className="title">{t('secE_sec1_title')}</p>
                        </div>
                        <div className="text-ani text2">
                            <p className="title">{t('secE_sec2_title')}</p>
                        </div>
                        <div className="text-ani text3">
                            <p className="subtitle">{t('secE_sec3_subtitle')}</p>
                            <p className="title">{t('secE_sec3_title')}</p>
                            <p className="desc">{t('secE_sec3_desc')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function transformToBob(finalyUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
        const req = new XMLHttpRequest();
        req.open('GET', finalyUrl, true);
        req.responseType = 'blob';
        req.onload = async function () {
            if (this.status === 200) {
                const videoBlob = this.response;
                const blobSrc = URL.createObjectURL(videoBlob);
                resolve(blobSrc);
            } else {
                reject();
            }
        };
        req.onerror = reject;
        req.send();
    });
}
